<template>

    <VueFinalModal v-model="showModal" classes="modal-container" content-class="modal-content4">

        <pacientes @datos-seleccionados="handleDatosSeleccionados2" />

    </VueFinalModal>

    <div class="card mt-3" style="margin-bottom:10px">
        <div class=" card-body">
            <div class="row">

                <div>
                    <p class="mb-1 text-end"><strong>Fecha: </strong> {{ pacientes.fecha }}</p>
                </div>

                <div class="row mb-3">

                    <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                        <div class="d-flex align-items-center">
                            <p class="mb-0 me-6"><strong>Dni: </strong>{{ pacientes.cedula }}</p>
                            <i @click="loadModal" class="fas fa-search text-primary"
                                style="cursor: pointer; font-size: 14px;"></i>
                        </div>
                    </div>

                    <div class="col-12 col-sm-6 col-md-4 col-lg-5">
                        <p class="mb-1"><strong>Nombres: </strong>{{ pacientes.nombres }}</p>
                    </div>

                    <div class="col-12 col-sm-6 col-md-4 col-lg-4">
                        <p class="mb-1"><strong>Edad: </strong>{{ pacientes.edad }}</p>
                    </div>

                </div>


                <h6 style="background: #0078be!important;" class="card-title bg-primary text-white w-100 p-1">
                    ORDEN DE EXÁMEN
                </h6>

                <div class="row">
                    <div class="col-md-4" v-for="(category, index) in examenes" :key="index">
                        <label class="form-check-label" style="font-size: 15px; color: black;"><b>{{ category.name
                        }}</b></label>
                        <div v-for="(exam, idx) in category.items" :key="idx" class="form-check"
                            style="margin-top: -10px; margin-left: 10px;">
                            <input class="form-check-input" type="checkbox" :disabled="noGenerarOrden"
                                :id="`${category.name}-${exam}`" v-model="selectedExams"
                                :value="`${category.name}-${exam}`" />
                            <label class="form-check-label mt-0" style="font-size: 12px; color: black;"
                                :for="`${category.name}-${exam}`">{{ exam }}</label>
                        </div>
                    </div>

                    <!-- Textarea para Otros examenes -->
                    <div class="row">
                        <div class="col-12">
                            <label class="form-check-label" style="font-size: 15px; color: black;"><b>Otros:</b></label>
                            <textarea class="form-control" rows="3" v-model="otros"
                                :disabled="noGenerarOrden"></textarea>
                        </div>
                    </div>


                </div>

                <div class="text-center mt-3">
                    <button class="btn btn-success" @click="Imprimir">Imprimir</button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import { VueFinalModal } from "vue-final-modal";
import "vue-final-modal/style.css";
import { generatePdfExamen } from './Impresion';
import Pacientes from "../Receta/Pacientes.vue";

export default {
    name: "OrdenExamenes",
    components: {
        VueFinalModal,
        Pacientes
    },

    data() {
        return {
            showModal: false,
            selectedExams: [],
            noGenerarOrden: false,
            exameneSeleccionados: [],
            pacientes: {
                cedula: '',
                nombres: '',
                edad: '',
                fecha: ''
            },
            otros: "",
            examenes: [
                { name: "Hematología", items: ["Biometría Hemática Completa", "Eritrosedimentación", "Inv. De Hematocrito", "Grupo Sanguíneo", "Reticulocitos", "Anormalidades Citológicas", "Ferritina", "Transferrina", "Ácido Fólico", "Glucosa 6 Fosfato"] },
                { name: "Enzimas", items: ["T.G.O.", "T.G.P.", "Fosf. Alcalina", "G.G.T.", "Fosf. Acida Total", "Amilasa", "Lipasa", "C.P.K.", "C.K.-MB.", "Colinesterasa"] },
                { name: "Hemostasia", items: ["Plaquetas", "T. de Coagulación", "T. de Sangría", "T. de Protrombina", "T. de Tromboplastina", "Fibrinógeno"] },
                { name: "Inmunología", items: ["Helicobacter Pylori IgG - IgM", "Dengue IgG - IgM", "Dengue NS21", "V.I.H.", "Toxoplasma IgG - IgM", "Rubeola IgG - IgM", "Citomegalovirus IgG - IgM", "Herpes I", "Herpes II", "Hep. A", "Hep. B", "Hep. C", "Cisticercos", "Clamidias en sangre", "Mononucleosis Infecciosa", "Tuberculosis sérica", "Complementos C3 - C4", "IgA", "IgM", "IgG", "IgE", "Anticuerpos Antinucleares (ANA)", "Anticuerpos Anti TPO", "Anti-Tiroglobulina", "Anti-Tiroglobulina Anti TPO", "Anti-Péptido Ciclutrulinado", "Ac. Antifosfolípidos", "Ac. Anti-DNA", "Ac. Antifosfolípidos Lúpico"] },
                { name: "Química Sanguínea", items: ["Glucosa", "Glucosa post prandial", "Tolerancia a la Glucosa", "Hb. Glicosilada", "Urea", "Creatinina", "Ácido Úrico", "Colesterol", "Colesterol HDL", "Colesterol LDL", "Triglicéridos", "Lípidos Totales", "Proteínas Totales", "Albuminas", "Globulinas", "Bilirrubina Total", "Bilirrubina Directa", "Bilirrubina Indirecta"] },
                { name: "Hormonas", items: ["T3", "T4", "TSH", "T3 Libre", "T4 Libre", "Prolactina", "Progesterona", "Tiroglobulina", "LH", "F.S.H.", "Estradiol", "Cortisol am", "Cortisol pm", "Insulina", "Beta HCG cuantitativo", "Beta HCG cualitativo"] },
                { name: "Marcadores Tumorales", items: ["PSA Total", "PSA Libre", "Antígeno Carcinoembrionario (CEA)", "Alfafetoproteína (AFP)", "CA 125 (CA de Ovario)", "CA 19-9 (CA de Páncreas)", "CA 15-3 (CA de Mamas)", "CA 72-4 (CA de Estómago)"] },
                { name: "Orina", items: ["Elemental y Microscópico", "Gram de gota Fresca", "Cultivo y Antibiograma", "Microalbuminuria", "Clearance de Creatinina", "Proteínas en Orina 24 horas", "Panel de Drogas"] },
                { name: "Heces", items: ["Coproparasitario", "Seriado", "coprológico", "Sangre Oculta", "Coprocultivo", "Rotavirus", "Azucares Reductores", "Helicobacter en Heces"] },
                { name: "Electrolitos", items: ["Sodio", "Potasio", "Hierro", "Cloro", "Fósforo", "pH", "Calcio", "Magnesio"] },
                { name: "Serología", items: ["A.S.T.O", "P.C.R.", "F.R.", "V.D.R.L.", "Widal Weill Felix", "Brucella Abortus"] },
                { name: "Esputo", items: ["Baciloscopia", "Tinción de Gram", "Cultivo y Antibiograma"] },
                { name: "Bacteriología", items: ["Cultivo y Antibiograma", "Cultivo para Hongos", "KOH", "Coloración de Gram"] }
            ],
        };
    },
    watch: {
        otros(newValue) {
            if (newValue !== newValue.toUpperCase()) {
                this.otros = newValue.toUpperCase();
            }
        }
    },
    methods: {

        loadModal() {
            this.showModal = true
        },

        handleDatosSeleccionados2(resp) {

            if (resp && resp.cedula !== undefined && resp.cedula !== '') {

                const formatter = new Intl.DateTimeFormat('es-ES', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                });

                this.pacientes = {
                    cedula: resp.cedula,
                    nombres: resp.nombres_pacientes,
                    edad: this.calcularEdad(resp.nacimiento),
                    fecha: formatter.format(new Date())
                };

                this.showModal = false
            }

        },

        async Imprimir() {

            const examenesAgrupados = {};

            // Recorrer los exámenes seleccionados
            this.selectedExams.forEach((exam) => {
                // Separar solo en el primer "-" para no cortar nombres con guiones (ej. "IgG - IgM")
                const separatorIndex = exam.indexOf("-");
                const categoria = exam.substring(0, separatorIndex);
                const nombreExamen = exam.substring(separatorIndex + 1);

                // Si la categoría no existe en el objeto, la creamos
                if (!examenesAgrupados[categoria]) {
                    examenesAgrupados[categoria] = [];
                }

                // Agregar el examen a la categoría correspondiente
                examenesAgrupados[categoria].push(nombreExamen);
            });

            // Crear el objeto JSON final
            const resultado = {
                examenes: Object.keys(examenesAgrupados).length > 0 ? examenesAgrupados : null,
                otros: this.otros.trim() !== "" ? this.otros : null
            };
            this.exameneSeleccionados = resultado

            if (!resultado.examenes && !resultado.otros) {
                this.$swal.fire({
                    title: "Campos incompletos",
                    text: "Por favor, debe especificar el exámen. No se puede continuar.",
                    icon: "warning",
                    confirmButtonText: 'Aceptar',
                    customClass: {
                        confirmButton: "btn btn-primary"
                    },
                    buttonsStyling: false,
                });
                return;
            }



            if (this.pacientes && this.pacientes.cedula !== undefined && this.pacientes.cedula !== '') {

                await generatePdfExamen(this.exameneSeleccionados, this.pacientes)
            } else {

                this.$swal.fire({
                    title: "Campos incompletos",
                    text: "Por favor, debe seleccionar el paciente para seguir.",
                    icon: "warning",
                    confirmButtonText: 'Aceptar',
                    customClass: {
                        confirmButton: "btn btn-primary"
                    },
                    buttonsStyling: false,
                });
                return;
            }

        }

    }
};
</script>

<style scoped>
.form-check-input {
    margin-right: 5px;
}
</style>